import { isRdEmbedded } from './embedded';

/**
 * Reflective Data: when framed by the RD app, tell it what is open (the page's path and title), so its Agent can answer
 * "add a metric to this chart". Nothing is read from the parent, and it only ever sends this one small message.
 */
const startRdContextReporting = () => {
    if (!isRdEmbedded) return;
    let last = '';
    const send = () => {
        const msg = `${window.location.pathname}${window.location.search}|${document.title}`;
        if (msg === last) return;
        last = msg;
        window.parent.postMessage(
            {
                type: 'rd-context',
                path: `${window.location.pathname}${window.location.search}`,
                title: document.title,
            },
            '*',
        );
    };
    window.setInterval(send, 700);
    send();
};

startRdContextReporting();
